import api from "./api";

export interface UploadAppLogOptions {
  /** base64-encoded gzip bytes, as produced by the native DebugLogs plugin. */
  gzippedBase64: string;
  appVersion: string;
  platform: string;
}

export interface AppLogBundle {
  ID: string;
  UserID: string;
  UserSessionID?: string;
  UploadedAt: string;
  ExpiresAt: string;
  SizeBytes: number;
  AppVersion: string;
  Platform: string;
}

export interface AppLogBundleContent {
  Content: string;
  Truncated: boolean;
  SizeBytes: number;
}

async function uploadAppLogBundle(opts: UploadAppLogOptions): Promise<void> {
  // base64-in-JSON, not raw Blob: CapacitorHttp doesn't reliably ferry Blob bodies.
  await api.post("/user/app-logs", {
    AppVersion: opts.appVersion,
    Platform: opts.platform,
    Data: opts.gzippedBase64,
  });
}

async function listAppLogBundles(): Promise<AppLogBundle[]> {
  const res = await api.get<AppLogBundle[]>("/admin/app-logs");
  return res.data ?? [];
}

async function getAppLogBundleContent(bundleId: string): Promise<AppLogBundleContent> {
  const res = await api.get<AppLogBundleContent>(`/admin/app-logs/${bundleId}/content`);
  return res.data;
}

async function deleteAppLogBundle(bundleId: string): Promise<void> {
  await api.delete(`/admin/app-logs/${bundleId}`);
}

function downloadUrl(bundleId: string): string {
  return `/api/admin/app-logs/${bundleId}/download`;
}

export default {
  uploadAppLogBundle,
  listAppLogBundles,
  getAppLogBundleContent,
  deleteAppLogBundle,
  downloadUrl,
};
